import { join } from 'juriquery'

import { Query } from '../types'

export const ACCREDITATION_ROOT_ROUTE = '/accreditation'

export const ACCREDITATION_STANDARDS_ROUTE = `${ACCREDITATION_ROOT_ROUTE}/clinics/:clinicId/standards`
export const ACCREDITATION_TASKS_ROUTE = `${ACCREDITATION_ROOT_ROUTE}/clinics/:clinicId/tasks`

export const ACCREDITATION_STANDARD_ROUTE = ':standardId'
export const ACCREDITATION_STANDARD_RELEASE_NOTES_ROUTE =
  ':standardId/release-notes'
export const ACCREDITATION_STANDARD_ACKNOWLEDGE_ROUTE =
  ':standardId/acknowledge'

const getRouteWithInjectedStandardId = (route: string, standardId: number) =>
  route.replace(':standardId', `${standardId}`)

export const getAccreditationStandardsRoute = (clinicId: number) =>
  ACCREDITATION_STANDARDS_ROUTE.replace(':clinicId', `${clinicId}`)

export const getAccreditationTasksRoute = (clinicId: number, query?: Query) =>
  join(ACCREDITATION_TASKS_ROUTE.replace(':clinicId', `${clinicId}`), query)

export const getAccreditationStandardRoute = (
  clinicId: number,
  standardId: number,
): string =>
  `${getAccreditationStandardsRoute(clinicId)}/${getRouteWithInjectedStandardId(
    ACCREDITATION_STANDARD_ROUTE,
    standardId,
  )}`

export const getAccreditationStandardReleaseNotesRoute = (
  clinicId: number,
  standardId: number,
) =>
  `${getAccreditationStandardsRoute(clinicId)}/${getRouteWithInjectedStandardId(
    ACCREDITATION_STANDARD_RELEASE_NOTES_ROUTE,
    standardId,
  )}`

export const getAccreditationStandardAcknowledgeRoute = (
  clinicId: number,
  standardId: number,
) =>
  `${getAccreditationStandardsRoute(clinicId)}/${getRouteWithInjectedStandardId(
    ACCREDITATION_STANDARD_ACKNOWLEDGE_ROUTE,
    standardId,
  )}`
